{
  "version": 1,
  "asset_id": "a87f8804-7b65-4197-9745-1402d590b0db",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a87f8804-7b65-4197-9745-1402d590b0db/sleeve-amateur-1.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a87f8804-7b65-4197-9745-1402d590b0db/sleeve-amateur-1.webp",
  "original_filename": "sleeve-amateur-1.webp",
  "size": 18322,
  "content_type": "image/webp",
  "created_at": "2026-08-15T18:28:47Z"
}
